module.exports = __webpack_public_path__ + "img/D户型1.0227e9ff.png";